/**
 * DOM ready check
 */
export const ready = (fn: () => any) => {
  const state = document.readyState;

  if (typeof fn !== 'function') {
    return;
  }

  if (state === 'interactive' || state === 'complete') {
    return fn();
  }

  document.addEventListener('DOMContentLoaded', fn, {
    capture: false,
    once: true,
  });
};
